import { useDraggable } from '@dnd-kit/core';
import React from 'react';

import { AttachedToOfferIcon } from './AttachedToOfferIcon';
import { Container, Frame, Name } from './ImageCardStyles';
import { LazyImage } from './LazyImage';
import { MenuEditorDragData } from '../dnd/types';

type Props = {
  attachedToOffer: boolean;
  blurhash: string;
  name: string;
  src: string;
};

export const ImageCard = ({ attachedToOffer, src, name, blurhash }: Props) => {
  const dndData: MenuEditorDragData = {
    type: 'DND_IMAGE_GALLERY_ASSET',
    imageData: {
      url: src,
      blurhash,
    },
    dragOverlay: (
      <Container $dragged>
        <Frame>
          <LazyImage src={src} alt={name} blurhash={blurhash} />
        </Frame>
        <Name title={name}>{name}</Name>
      </Container>
    ),
  };

  const { attributes, listeners, setNodeRef } = useDraggable({
    id: src,
    data: dndData,
  });

  return (
    <Container ref={setNodeRef} {...attributes} {...listeners}>
      <Frame>
        <LazyImage src={src} alt={name} blurhash={blurhash} />
      </Frame>
      <Name title={name}>{name}</Name>
      {attachedToOffer && <AttachedToOfferIcon />}
    </Container>
  );
};
